//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Carries the "webhook created" success message across the full-page
 * navigation to Keycloak and back (OAuth-required creation). React state is
 * lost on that round trip — sessionStorage is what survives it.
 */
const STORAGE_KEY = 'webhook_created_toast';

/** Call before redirecting the browser away for OAuth. */
export function setPendingWebhookCreatedToast(message: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, message);
  } catch {
    // sessionStorage unavailable (private browsing, disabled storage) — the
    // webhook is still created; only the post-redirect toast is skipped.
  }
}

/** Call once on mount; returns the message (and clears it) if one is pending. */
export function consumePendingWebhookCreatedToast(): string | null {
  try {
    const message = sessionStorage.getItem(STORAGE_KEY);
    if (message) sessionStorage.removeItem(STORAGE_KEY);
    return message;
  } catch {
    return null;
  }
}
